import { StaticImage } from "gatsby-plugin-image"
import gsap from "gsap"
import React, { useEffect, useRef } from "react"
import "./Loader.scss"

const Loader = ({ setLoading }) => {
    const $wrapper = useRef(null)
    const $background = useRef(null)
    const $logo = useRef(null)

    useEffect(() => {
        const ctx = gsap.context(() => {
            console.log("document", document)
            const tl = gsap.timeline({
                onStart: () => {
                    if (typeof document !== "undefined") {
                        document.body.classList.add(
                            "h-screen",
                            "!overflow-hidden"
                        )
                    }
                },
                onComplete: () => {
                    if (typeof document !== "undefined") {
                        document.body.classList.remove(
                            "h-screen",
                            "!overflow-hidden"
                        )
                    }

                    $wrapper.current.classList.add("invisible")

                    setLoading(false)
                }
            })

            tl.fromTo(
                $background.current,
                { scale: 0 },
                { scale: 1, opacity: 1, duration: 0.5 }
            ).to($background.current, {
                scale: 0,
                duration: 1.2,
                ease: "power3.inOut"
            })

            tl.to($logo.current, { opacity: 0, duration: 0.5 }, "<0.5")
        }, $wrapper)

        return () => {
            ctx.revert()
        }
    }, [])

    return (
        <div
            className="fixed inset-0 z-[100] grid h-screen place-items-center bg-white"
            ref={$wrapper}
        >
            <span
                className="absolute top-1/2 left-1/2 aspect-square w-[200vmax] -translate-x-1/2 -translate-y-1/2 scale-0 rounded-full bg-primary-color"
                ref={$background}
            ></span>

            <div className="loader z-50" ref={$logo}>
                <div className="aspect-square w-32 md:w-48">
                    <StaticImage
                        src="../../images/sd-logo.png"
                        className="h-full w-full"
                        alt="loading"
                        objectFit="cover"
                        loading="eager"
                    />
                </div>
            </div>
        </div>
    )
}

export default Loader
